import Tags from '~/src/molecules/Tags/';
import React from 'react';
import useSelectedPack from './useSelectedPack';

const FoodCategory = ({ ...rest }) => {
  const { additionalAttributes = {} } = useSelectedPack();
  const type = additionalAttributes?.info?.find((value) => value?.type === 'food_type')?.label;
  if (!type) return <></>;
  const foodType = type === 'veg' ? 'veg' : 'nonVeg';
  return (
    <div className="foodCategory absolute z-10" {...rest}>
      <Tags variant={foodType} />
      <style jsx>{`
        .foodCategory {
          bottom: 0.5rem;
          left: 0.5rem;
        }
      `}</style>
    </div>
  );
};

export default FoodCategory;
